/* eslint-disable react/no-unescaped-entities */
"use client";

import React, { useState } from "react";

import EnqueryForm from "@/components/forms/EnqueryForm";
import { FormHeading, SuccessMessageType } from "@/interface/types";

const DownArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.854 9.35375L8.35403 13.8538C8.30759 13.9002 8.25245 13.9371 8.19175 13.9623C8.13105 13.9874 8.06599 14.0004 8.00028 14.0004C7.93457 14.0004 7.86951 13.9874 7.80881 13.9623C7.74811 13.9371 7.69296 13.9002 7.64653 13.8538L3.14653 9.35375C3.05271 9.25993 3 9.13268 3 9C3 8.86732 3.05271 8.74007 3.14653 8.64625C3.24035 8.55243 3.3676 8.49972 3.50028 8.49972C3.63296 8.49972 3.76021 8.55243 3.85403 8.64625L7.50028 12.2931V2.5C7.50028 2.36739 7.55296 2.24021 7.64672 2.14645C7.74049 2.05268 7.86767 2 8.00028 2C8.13289 2 8.26006 2.05268 8.35383 2.14645C8.4476 2.24021 8.50028 2.36739 8.50028 2.5V12.2931L12.1465 8.64625C12.2403 8.55243 12.3676 8.49972 12.5003 8.49972C12.633 8.49972 12.7602 8.55243 12.854 8.64625C12.9478 8.74007 13.0006 8.86732 13.0006 9C13.0006 9.13268 12.9478 9.25993 12.854 9.35375Z"
      fill="#3399FF"
    />
  </svg>
);

// CMA (Certified Management Accountant) FAQs — sourced from doc
const faqsData = [
  {
    value: "item-1",
    question: "1. What is the U.S. CMA course?",
    answer: (
      <p className="answer">
        The U.S. CMA (Certified Management Accountant) is a globally recognized
        management accounting qualification focused on FP&amp;A, controllership,
        corporate finance, strategy, and business decision-making.
      </p>
    ),
  },
  {
    value: "item-2",
    question: "2. What is the full form of CMA?",
    answer: (
      <p className="answer">CMA stands for Certified Management Accountant.</p>
    ),
  },
  {
    value: "item-3",
    question: "3. Is U.S. CMA valid in India?",
    answer: (
      <p className="answer">
        Yes. U.S. CMA professionals are highly valued by MNCs, Global Capability
        Centers (GCCs), Big 4 firms, and multinational finance teams across
        India.
      </p>
    ),
  },
  {
    value: "item-4",
    question: "4. Is CMA better than CA?",
    answer: (
      <p className="answer">
        Both qualifications serve different career goals. CA is ideal for Indian
        statutory audit and taxation, while CMA is focused on management
        accounting, FP&amp;A, analytics, controllership, and finance leadership
        roles.
      </p>
    ),
  },
  {
    value: "item-5",
    question: "5. Is CMA good for corporate finance careers?",
    answer: (
      <p className="answer">
        Yes. US CMA is one of the best qualifications for careers in FP&amp;A,
        corporate finance, financial planning, strategy, and controllership.
      </p>
    ),
  },
  {
    value: "item-6",
    question: "6. How many exams are there in CMA?",
    answer: (
      <>
        <p className="answer">The US CMA course has only 2 exams:</p>
        <ul className="faqList">
          <li>Part 1 – Financial Planning, Performance &amp; Analytics</li>
          <li>Part 2 – Strategic Financial Management</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-7",
    question: "7. What is the duration of the CMA course?",
    answer: (
      <p className="answer">
        Most students complete the CMA course within 6–8 months.
      </p>
    ),
  },
  {
    value: "item-8",
    question: "8. Can working professionals pursue CMA?",
    answer: (
      <p className="answer">
        Yes. The CMA course is specifically designed for working professionals.
      </p>
    ),
  },
  {
    value: "item-9",
    question: "9. Is CMA easier than CA?",
    answer: (
      <>
        <p className="answer">
          Many students find CMA more manageable because:
        </p>
        <ul className="faqList">
          <li>It has only 2 exams</li>
          <li>Exams are computer-based</li>
          <li>You can study one exam at a time</li>
          <li>The course is designed around practical finance concepts</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-10",
    question: "10. Are CMA exams conducted in India?",
    answer: (
      <p className="answer">
        Yes. CMA exams are conducted at Prometric test centers in India.
      </p>
    ),
  },
  {
    value: "item-11",
    question: "11. What subjects are covered in CMA?",
    answer: (
      <>
        <p className="answer">The CMA syllabus includes:</p>
        <ul className="faqList">
          <li>FP&amp;A</li>
          <li>Cost Management</li>
          <li>Corporate Finance</li>
          <li>Strategic Financial Management</li>
          <li>Performance Analytics</li>
          <li>Risk Management</li>
          <li>Internal Controls</li>
          <li>Technology &amp; Analytics</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-12",
    question: "12. What is included in CMA Part 1?",
    answer: (
      <>
        <p className="answer">Part 1 covers:</p>
        <ul className="faqList">
          <li>Financial Planning</li>
          <li>Budgeting &amp; Forecasting</li>
          <li>Performance Management</li>
          <li>Cost Management</li>
          <li>Internal Controls</li>
          <li>Technology &amp; Analytics</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-13",
    question: "13. What is included in CMA Part 2?",
    answer: (
      <>
        <p className="answer">Part 2 covers:</p>
        <ul className="faqList">
          <li>Financial Statement Analysis</li>
          <li>Corporate Finance</li>
          <li>Decision Analysis</li>
          <li>Risk Management</li>
          <li>Investment Decisions</li>
          <li>Professional Ethics</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-14",
    question: "14. What is the CMA exam format?",
    answer: (
      <>
        <p className="answer">Each CMA exam consists of:</p>
        <ul className="faqList">
          <li>100 MCQs</li>
          <li>2 Case-Based Questions</li>
          <li>4-hour duration</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-15",
    question: "15. Are CMA exams MCQ-based?",
    answer: (
      <>
        <p className="answer">Yes. CMA exams are:</p>
        <ul className="faqList">
          <li>75% MCQs</li>
          <li>25% Case-Based Questions</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-16",
    question: "16. What is the pass rate for CMA?",
    answer: (
      <p className="answer">
        The global CMA pass rate is approximately 45%, while Miles students have
        a pass rate of around 76%.
      </p>
    ),
  },
  {
    value: "item-17",
    question: "17. Can B.Com students pursue CMA?",
    answer: (
      <p className="answer">
        Yes. B.Com students and graduates can pursue US CMA.
      </p>
    ),
  },
  {
    value: "item-18",
    question: "18. Can I pursue CMA during graduation?",
    answer: (
      <p className="answer">
        Yes. Students can appear for CMA exams alongside graduation and complete
        the remaining requirements later.
      </p>
    ),
  },
  {
    value: "item-19",
    question: "19. Is articleship required for CMA?",
    answer: (
      <p className="answer">No. CMA does not require articleship like CA.</p>
    ),
  },
  {
    value: "item-20",
    question: "20. Can engineers pursue CMA?",
    answer: (
      <p className="answer">
        Yes. Engineers interested in finance, analytics, and strategy can pursue
        CMA.
      </p>
    ),
  },
  {
    value: "item-21",
    question: "21. Is CMA globally recognized?",
    answer: (
      <p className="answer">
        Yes. The US CMA is recognized across 150+ countries globally.
      </p>
    ),
  },
  {
    value: "item-22",
    question: "22. What is the eligibility for CMA?",
    answer: (
      <>
        <p className="answer">The CMA qualification requires:</p>
        <ul className="faqList">
          <li>Passing both CMA exams</li>
          <li>A bachelor&apos;s degree</li>
          <li>2 years of relevant experience</li>
        </ul>
        <p className="answer">
          These requirements can be completed within 7 years after passing the
          exam.
        </p>
      </>
    ),
  },
  {
    value: "item-23",
    question: "23. What are the 3 Es of CMA?",
    answer: (
      <>
        <p className="answer">The 3 Es are:</p>
        <ul className="faqList">
          <li>Examination</li>
          <li>Education</li>
          <li>Experience</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-24",
    question: "24. Can I study one CMA exam at a time?",
    answer: (
      <p className="answer">
        Yes. Candidates get a 3-year window to clear both exams.
      </p>
    ),
  },
  {
    value: "item-25",
    question: "25. What are the CMA exam windows?",
    answer: (
      <>
        <p className="answer">CMA exams are conducted during:</p>
        <ul className="faqList">
          <li>January–February</li>
          <li>May–June</li>
          <li>September–October</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-26",
    question: "26. How many hours should I study for CMA?",
    answer: (
      <p className="answer">
        Most candidates study around 18–20 hours per week.
      </p>
    ),
  },
  {
    value: "item-27",
    question: "27. What is CAIRA?",
    answer: (
      <p className="answer">
        CAIRA stands for Certified AI-Ready Accountant. It is Miles
        Education&apos;s AI-integrated accounting and finance credential.
      </p>
    ),
  },
  {
    value: "item-28",
    question: "28. Why is CAIRA integrated with CMA?",
    answer: (
      <p className="answer">
        Modern finance teams increasingly use AI workflows, dashboards,
        automation systems, and analytics tools. CAIRA helps students become
        AI-ready finance professionals.
      </p>
    ),
  },
  {
    value: "item-29",
    question: "29. What AI tools are taught in CAIRA?",
    answer: (
      <>
        <p className="answer">Students learn:</p>
        <ul className="faqList">
          <li>Microsoft Copilot</li>
          <li>Power BI</li>
          <li>Power Automate</li>
          <li>Copilot Studio</li>
          <li>AI workflow systems</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-30",
    question: "30. What are AI workflows in finance?",
    answer: (
      <>
        <p className="answer">AI workflows automate:</p>
        <ul className="faqList">
          <li>Forecasting</li>
          <li>Variance Analysis</li>
          <li>Dashboarding</li>
          <li>KPI Tracking</li>
          <li>Financial Reporting</li>
          <li>Approvals &amp; Controls</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-31",
    question: "31. Will AI replace finance professionals?",
    answer: (
      <p className="answer">
        AI will automate repetitive finance tasks, but professionals who can
        work with AI systems will remain highly valuable.
      </p>
    ),
  },
  {
    value: "item-32",
    question: "32. What are examples of AI use cases taught in CMA + CAIRA?",
    answer: (
      <>
        <p className="answer">Students are exposed to:</p>
        <ul className="faqList">
          <li>Forecasting Agents</li>
          <li>Variance Analysis Workflows</li>
          <li>Working Capital Dashboards</li>
          <li>Balanced Scorecard Dashboards</li>
          <li>Risk Analytics Engines</li>
          <li>Fraud Detection Dashboards</li>
          <li>NPV &amp; IRR Capital Project Engines</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-33",
    question: "33. Why are firms hiring AI-ready finance professionals?",
    answer: (
      <p className="answer">
        Modern finance teams want professionals who can combine financial
        expertise with AI-driven execution and workflow automation.
      </p>
    ),
  },
  {
    value: "item-34",
    question: "34. Is CAIRA included with Miles CMA?",
    answer: (
      <p className="answer">
        Yes. CAIRA is integrated into the Miles CMA learning pathway.
      </p>
    ),
  },
  {
    value: "item-35",
    question: "35. What is an AI-ready finance professional?",
    answer: (
      <p className="answer">
        An AI-ready finance professional understands finance concepts along with
        AI workflows, automation, analytics, and AI-powered decision-making
        systems.
      </p>
    ),
  },
  {
    value: "item-36",
    question: "36. What jobs can I get after CMA?",
    answer: (
      <>
        <p className="answer">Popular roles include:</p>
        <ul className="faqList">
          <li>FP&amp;A Analyst</li>
          <li>Financial Analyst</li>
          <li>Finance Business Partner</li>
          <li>Controller</li>
          <li>Cost Accountant</li>
          <li>Corporate Finance Associate</li>
          <li>Strategy &amp; Planning Analyst</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-37",
    question: "37. Is CMA good for MNC jobs?",
    answer: (
      <p className="answer">
        Yes. MNCs and GCCs actively hire CMA professionals for finance and
        analytics roles.
      </p>
    ),
  },
  {
    value: "item-38",
    question: "38. What is the salary after CMA?",
    answer: (
      <p className="answer">
        Miles CMA alumni are placed at average salaries of ₹10–12 LPA+ depending
        on role and experience.
      </p>
    ),
  },
  {
    value: "item-39",
    question: "39. Are CMAs in demand?",
    answer: (
      <p className="answer">
        Yes. Demand for finance professionals with analytics and strategic
        finance skills is increasing rapidly across industries.
      </p>
    ),
  },
  {
    value: "item-40",
    question: "40. Can CMA help with leadership roles?",
    answer: (
      <p className="answer">
        Yes. CMA is strongly aligned with CFO-track and finance leadership
        roles.
      </p>
    ),
  },
  {
    value: "item-41",
    question: "41. Why choose Miles Education for CMA?",
    answer: (
      <>
        <p className="answer">Miles is:</p>
        <ul className="faqList">
          <li>IMA&apos;s Global Diamond Partner</li>
          <li>The world&apos;s largest CMA course provider</li>
          <li>One of the highest pass-rate providers globally</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-42",
    question: "42. Does Miles provide placement support?",
    answer: (
      <p className="answer">
        Yes. Miles provides placement support with Big 4 firms and 220+ MNCs.
      </p>
    ),
  },
  {
    value: "item-43",
    question: "43. Does Miles offer online CMA coaching?",
    answer: (
      <>
        <p className="answer">Yes. Miles offers:</p>
        <ul className="faqList">
          <li>Live online sessions</li>
          <li>Recorded lectures</li>
          <li>LMS support</li>
          <li>Mock exams</li>
          <li>Mentorship support</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-44",
    question: "44. What is the Miles One App?",
    answer: (
      <>
        <p className="answer">The Miles One App provides:</p>
        <ul className="faqList">
          <li>Concept videos</li>
          <li>MCQs</li>
          <li>Mock exams</li>
          <li>Case-based practice</li>
          <li>Progress tracking</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-45",
    question: "45. Does Miles provide face-to-face classes?",
    answer: (
      <p className="answer">
        Yes. Miles conducts face-to-face classes across multiple Indian cities.
      </p>
    ),
  },
  {
    value: "item-46",
    question: "46. What is the Miles CMA pass rate?",
    answer: (
      <p className="answer">
        Miles has an approximate CMA pass rate of 76% compared to the global
        average of 45%.
      </p>
    ),
  },
  {
    value: "item-47",
    question: "47. What study materials are provided by Miles?",
    answer: (
      <>
        <p className="answer">Students receive:</p>
        <ul className="faqList">
          <li>McGraw Hill books</li>
          <li>5,000+ MCQs</li>
          <li>125+ Case-Based Questions</li>
          <li>Mock exams</li>
          <li>Practice exams</li>
          <li>Structured LMS support</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-48",
    question: "48. Does Miles offer mentorship support?",
    answer: (
      <>
        <p className="answer">Yes. Students receive:</p>
        <ul className="faqList">
          <li>1:1 mentoring</li>
          <li>Career guidance</li>
          <li>Strategy sessions</li>
          <li>License track support</li>
        </ul>
      </>
    ),
  },
  {
    value: "item-49",
    question: "49. Does Miles support AI learning for finance professionals?",
    answer: (
      <p className="answer">
        Yes. CAIRA is fully integrated into the Miles CMA journey with AI
        workflows, analytics, automation, and AI agents.
      </p>
    ),
  },
  {
    value: "item-50",
    question: "50. Why is CMA considered future-ready?",
    answer: (
      <p className="answer">
        The CMA qualification now focuses heavily on analytics, planning,
        performance management, and AI-enabled finance workflows, making it
        highly aligned with the future of finance.
      </p>
    ),
  },
];

const cmaData = [
  {
    value: "cma-1",
    question: "What is the U.S. CMA course?",
    answer: (
      <div className="about-section-content">
        <p>
          The <strong>U.S. CMA (Certified Management Accountant)</strong> is the
          world&apos;s most respected management accounting qualification,
          administered by the{" "}
          <strong>IMA (Institute of Management Accountants)</strong> and
          recognized across 150+ countries. It is the professional gold standard
          for careers in FP&amp;A, controllership, corporate finance, and
          management accounting at MNCs, GCCs, and Fortune 500 companies.
        </p>
        <ul className="about-section-list">
          <li>
            <strong>Yesterday&apos;s finance professional:</strong> Prepares.
            Tracks. Reports. Reconciles. Explains.
          </li>
          <li>
            <strong>Tomorrow&apos;s CMA:</strong> Interprets AI outputs. Builds
            forecasts. Designs workflows. Drives decisions. Owns outcomes.
          </li>
          <li>
            The new hiring question at Big 4 firms and MNCs: &ldquo;Can you help
            us use AI for planning, analysis, and decision-making?&rdquo;{" "}
            <strong>CMA prep must change too.</strong>
          </li>
          <li>
            Miles Education, the world&apos;s largest CMA course provider and{" "}
            <strong>IMA&apos;s Diamond Partner</strong>, has integrated the US
            CMA course with{" "}
            <strong>CAIRA (Certified AI-Ready Accountant)</strong> &mdash; the
            only program in the world that combines a globally recognized
            management accounting credential with structured AI workflow
            training built for finance professionals.
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-2",
    question: "What Does CMA Stand For?",
    answer: (
      <div className="about-section-content">
        <p>
          <strong>CMA stands for Certified Management Accountant.</strong> It is
          a globally recognized professional credential issued by the{" "}
          <strong>IMA (Institute of Management Accountants)</strong>, the
          world&apos;s leading association of accountants and financial
          professionals in business.
        </p>
        <ul className="about-section-list">
          <li>
            Designed for finance professionals working <em>inside</em>{" "}
            organizations &mdash; the CFO&apos;s team
          </li>
          <li>
            Mandate: drive planning, performance measurement, cost management,
            and strategic decision-making
          </li>
          <li>
            For Indian candidates, the <strong>US CMA</strong> is the management
            accounting credential of choice for roles at MNCs, GCCs, Big 4
            advisory practices, and multinational finance centers
          </li>
          <li>
            Not to be confused with the Indian CMA (ICMAI), which is a domestic
            qualification with a different syllabus and market positioning
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-3",
    question: "U.S. CMA Exam Details & Structure",
    answer: (
      <div className="about-section-content">
        <p>
          The <strong>U.S. CMA exam</strong> consists of just 2 parts &mdash;
          making it one of the most efficient professional qualifications in the
          world. Both exams are 4 hours each and are 75% computer-graded.
        </p>
        <ul className="about-section-list">
          <li>
            <strong>
              Part 1 &mdash; Financial Planning, Performance &amp; Analytics:
            </strong>{" "}
            External Financial Reporting Decisions (15%) · Planning, Budgeting
            &amp; Forecasting (20%) · Performance Management (20%) · Cost
            Management (15%) · Internal Controls (15%) · Technology &amp;
            Analytics (15%). CAIRA AI use cases: driver-based rolling forecast
            agents, scenario &amp; sensitivity modeling, flexible budget
            variance agents, balanced scorecard dashboards, ABC costing
            allocation engines, SOX control testing workflows, fraud anomaly
            detection, predictive AR collections scoring
          </li>
          <li>
            <strong>Part 2 &mdash; Strategic Financial Management:</strong>{" "}
            Financial Statement Analysis (20%) · Corporate Finance (20%) ·
            Decision Analysis (25%) · Risk Management (10%) · Investment
            Decisions (10%) · Professional Ethics (15%). CAIRA AI use cases:
            ratio &amp; peer benchmark dashboards, WACC &amp; cost-of-capital
            agents, working capital release modeling, make-or-buy decision
            engines, CVP &amp; breakeven modeling, NPV/IRR capital project
            ranking, enterprise risk register agents, IMA ethics decision
            advisor
          </li>
        </ul>
        <p>
          <strong>CMA Exam Format at a Glance:</strong>
        </p>
        <ul className="about-section-list">
          <li>100 MCQs + 2 Case-Based Questions per part (4 hours total)</li>
          <li>75% MCQs + 25% Case-Based Questions</li>
          <li>
            Exam windows: January&ndash;February, May&ndash;June,
            September&ndash;October
          </li>
          <li>
            3-year window to pass both exams &mdash; study one exam at a time
          </li>
          <li>You decide your exam date within the window</li>
          <li>
            CMA = CPA (&minus;) Audit (&minus;) Tax &mdash; ideal for FP&amp;A,
            controllership, corporate finance, and strategy, rather than public
            accounting
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-4",
    question: "U.S. CMA Exam Eligibility",
    answer: (
      <div className="about-section-content">
        <p>
          <strong>U.S. CMA exam eligibility</strong> is governed by the IMA. The
          requirements are straightforward.
        </p>
        <p>
          <strong>3 Es to Becoming a CMA:</strong>
        </p>
        <ul className="about-section-list">
          <li>
            <strong>1. Examination</strong> &mdash; clear Part 1 and Part 2 of
            the CMA exam
          </li>
          <li>
            <strong>2. Education</strong> &mdash; a bachelor&apos;s degree from
            an accredited institution. Can be completed prior to or within 7
            years of passing the exam; students currently pursuing their degree
            are eligible to take the CMA exam
          </li>
          <li>
            <strong>3. Experience</strong> &mdash; 2 years of professional
            experience in management accounting or financial management. Can
            also be completed prior to or within 7 years of passing the exam
          </li>
          <li>
            <strong>Eligible backgrounds include:</strong> B.Com · M.Com · MBA
            (Finance) · CA / CS / ICMAI CMA · BBA · B.Sc (Accounting) ·
            Engineering + Finance · working professionals in accounting and
            finance
          </li>
          <li>
            <strong>Students:</strong> Can clear both parts of the CMA exam
            alongside graduation and fulfill the other requirements later
          </li>
          <li>
            <strong>Professionals with 2+ years of experience:</strong> Only
            need to clear the 2-part CMA exam to earn the CMA designation
            immediately
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-5",
    question: "U.S. CMA Syllabus: What You Actually Study",
    answer: (
      <div className="about-section-content">
        <p>
          The <strong>U.S. CMA syllabus</strong> is designed for finance
          professionals working inside organizations &mdash; the people who
          build the numbers, not just report them.
        </p>
        <ul className="about-section-list">
          <li>
            <strong>
              CMA Part 1 &mdash; Financial Planning, Performance &amp;
              Analytics:
            </strong>{" "}
            External Financial Reporting Decisions (US GAAP essentials, revenue
            recognition, leases, business combinations); Planning, Budgeting
            &amp; Forecasting (annual budgeting, rolling forecasts, driver-based
            models); Performance Management (variance analysis, responsibility
            accounting, balanced scorecard, KPI frameworks); Cost Management
            (ABC, standard costing, joint product costing, process costing);
            Internal Controls (SOX compliance, control frameworks, fraud
            detection); Technology &amp; Analytics (data analysis,
            visualizations &mdash; where CAIRA integration adds the most
            real-world depth)
          </li>
          <li>
            <strong>CMA Part 2 &mdash; Strategic Financial Management:</strong>{" "}
            Financial Statement Analysis (ratio analysis, earnings quality, peer
            benchmarking); Corporate Finance (capital structure, WACC, dividend
            policy, working capital optimization); Decision Analysis (relevant
            cost analysis, make-or-buy decisions, pricing strategy, linear
            programming); Risk Management (enterprise risk, FX exposure,
            interest rate risk, hedging); Investment Decisions (capital
            budgeting &mdash; NPV, IRR, payback, project evaluation);
            Professional Ethics (IMA Statement of Ethical Professional Practice
            and real-world frameworks)
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-6",
    question: "CMA vs CA: What's the Difference?",
    answer: (
      <div className="about-section-content">
        <div className="faqTableWrapper">
          <table className="faqTable">
            <thead>
              <tr>
                <th aria-label="Comparison criterion" />
                <th>
                  <strong>CA (ICAI)</strong>
                </th>
                <th>
                  <strong>U.S. CMA (IMA)</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Authority</strong>
                </td>
                <td>ICAI (India)</td>
                <td>IMA (USA &mdash; global)</td>
              </tr>
              <tr>
                <td>
                  <strong>Structure</strong>
                </td>
                <td>3 levels, 16 exams</td>
                <td>2 exams only</td>
              </tr>
              <tr>
                <td>
                  <strong>Timeline</strong>
                </td>
                <td>4&ndash;6 years</td>
                <td>6&ndash;8 months</td>
              </tr>
              <tr>
                <td>
                  <strong>Entry</strong>
                </td>
                <td>After Class XII</td>
                <td>After graduation (exams during UG allowed)</td>
              </tr>
              <tr>
                <td>
                  <strong>Focus</strong>
                </td>
                <td>Ind AS, Indian taxation, statutory audit</td>
                <td>
                  Management accounting, FP&amp;A, corporate finance, strategy
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Best for</strong>
                </td>
                <td>Indian CA firms, domestic roles, statutory audit</td>
                <td>MNCs, GCCs, Big 4 advisory, CFO-track roles</td>
              </tr>
              <tr>
                <td>
                  <strong>AI curriculum</strong>
                </td>
                <td>None</td>
                <td>Integrated with CAIRA</td>
              </tr>
              <tr>
                <td>
                  <strong>Graduation required</strong>
                </td>
                <td>No (substitutes university)</td>
                <td>Yes (complements university)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          If your goal is to work inside a company in FP&amp;A, controllership,
          corporate finance, or on a CFO track, the US CMA is the right
          qualification. It is designed for the finance professional who drives
          business decisions, not the external auditor or tax preparer.
        </p>
      </div>
    ),
  },
  {
    value: "cma-7",
    question: "CMA Course Duration & Format",
    answer: (
      <div className="about-section-content">
        <p>
          The U.S. <strong>CMA course</strong> is designed to fit around your
          life &mdash; whether you are a working professional or a student
          appearing for exams alongside graduation.
        </p>
        <p>
          <strong>Full CMA course details:</strong>
        </p>
        <ul className="about-section-list">
          <li>2 exam parts</li>
          <li>6&ndash;8 months to complete</li>
          <li>
            Exam windows 6 months every year (Jan&ndash;Feb, May&ndash;Jun,
            Sep&ndash;Oct)
          </li>
          <li>18&ndash;20 study hours per week</li>
          <li>75% MCQs + 25% Case-Based Questions · 75% computer-graded</li>
          <li>3-year window after registration to pass both exams</li>
          <li>
            <strong>Miles CMA pass rate: ~76%</strong> vs global average of ~45%
            &mdash; the reason Miles is IMA&apos;s Diamond Partner and the
            world&apos;s largest CMA course provider
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-8",
    question: "CMA Course Fees in India",
    answer: (
      <div className="about-section-content">
        <p>
          Full <strong>CMA course fees in India</strong> at Miles Education,
          including the discounted IMA fees available exclusively through Miles
          as IMA&apos;s Diamond Partner.
        </p>
        <p>
          <strong>Miles Program Fees:</strong>
        </p>
        <div className="faqTableWrapper">
          <table className="faqTable">
            <thead>
              <tr>
                <th>
                  <strong>Component</strong>
                </th>
                <th>
                  <strong>Fee</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>CMA Study Materials</td>
                <td>₹49,000</td>
              </tr>
              <tr>
                <td>CMA Training Fees</td>
                <td>₹40,000</td>
              </tr>
              <tr>
                <td>
                  <strong>CMA Total</strong>
                </td>
                <td>
                  <strong>₹89,000</strong>
                </td>
              </tr>
              <tr>
                <td>CAIRA (discounted bundle)</td>
                <td>₹50,000</td>
              </tr>
              <tr>
                <td>
                  <strong>CMA + CAIRA Bundle</strong>
                </td>
                <td>
                  <strong>₹1,49,000</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          <strong>EMI:</strong> ₹9,083/month over 12 months &mdash; zero
          interest, zero processing fees (₹30,000 upfront).
        </p>
        <p>
          <strong>IMA Fees (payable to IMA):</strong> Miles candidates receive
          exclusive bundle discounts on IMA fees as students of IMA&apos;s
          Diamond Partner.
        </p>
        <div className="faqTableWrapper">
          <table className="faqTable">
            <thead>
              <tr>
                <th>
                  <strong>IMA Fee Component</strong>
                </th>
                <th>
                  <strong>Students</strong>
                </th>
                <th>
                  <strong>Professionals</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>IMA Membership + Entrance + Exam Fees (Gross)</td>
                <td>~$1,400</td>
                <td>~$1,988</td>
              </tr>
              <tr>
                <td>Less: Miles bundle discount</td>
                <td>~$534</td>
                <td>~$573</td>
              </tr>
              <tr>
                <td>
                  <strong>Net IMA Fees</strong>
                </td>
                <td>
                  <strong>~$866</strong>
                </td>
                <td>
                  <strong>~$1,415</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          No other CMA coaching institute or CMA institute in India can offer
          these IMA fee savings &mdash; they are exclusive to Miles as
          IMA&apos;s Diamond Partner.
        </p>
      </div>
    ),
  },
  {
    value: "cma-9",
    question: "CMA + CAIRA: The AI-Ready Management Accountant",
    answer: (
      <div className="about-section-content">
        <p>
          The firms hiring right now want finance professionals who can{" "}
          <strong>build, automate, and govern</strong> &mdash; not just prepare
          and analyze. Miles integrated CAIRA as a parallel AI curriculum that
          runs alongside every CMA exam part.
        </p>
        <ul className="about-section-list">
          <li>
            <strong>CMA gives you professional credibility:</strong> globally
            recognized management accounting credential · FP&amp;A, cost
            management, corporate finance &amp; strategy expertise · pathways to
            Big 4 advisory, MNCs, GCCs, and CFO-track roles
          </li>
          <li>
            <strong>CAIRA gives you the AI edge:</strong> Microsoft 365 Copilot
            · Power BI · Power Automate · Copilot Studio · 3 Levels · 90 Hours ·
            NASBA-approved CPE · CAIRA Level 1 badge on LinkedIn within 4 months
          </li>
          <li>
            <strong>CAIRA Level 1: AI Foundations</strong> &mdash; master the
            Microsoft AI stack (Prompts → Analytics → Automations → Agents)
          </li>
          <li>
            <strong>CAIRA Level 2: Applied AI</strong> &mdash; AI-first shift
            across FP&amp;A, close, controllership, and planning workflows
          </li>
          <li>
            <strong>CAIRA Level 3: AI Leadership</strong> &mdash; firm-wide AI
            operating model, agents at scale, governance and trust
          </li>
          <li>
            <strong>
              CMA tells firms you understand finance. CAIRA shows them you can
              work like the future.
            </strong>{" "}
            By month 4, you can earn your CAIRA Level 1 badge and showcase it on
            LinkedIn before you&apos;ve even cleared your first CMA exam
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-10",
    question: "U.S. CMA Jobs in India: Career & Salary",
    answer: (
      <div className="about-section-content">
        <p>
          U.S. CMA professionals are among the most in-demand finance talent at
          MNCs and GCCs operating in India. The CMA certification opens doors to
          the highest-value finance roles &mdash; the ones driving business
          decisions, not just reporting on them.
        </p>
        <ul className="about-section-list">
          <li>
            <strong>CMA course salary in India:</strong> ₹10 Lakhs+ average
            (placed Miles CMA alumni)
          </li>
          <li>
            <strong>CMA job salary in the U.S.:</strong> ~$70,000&ndash;$130,000
            USD
          </li>
          <li>
            <strong>MNCs actively hiring Miles CMAs:</strong> 220+
          </li>
          <li>
            <strong>Common CMA job titles:</strong> Financial Analyst · FP&amp;A
            Analyst · FP&amp;A Manager · Management Accountant · Corporate
            Finance Associate · Controller · Finance Business Partner · Cost
            Accountant · CFO Track Associate · Strategy &amp; Planning Analyst ·
            Risk &amp; Controls Analyst
          </li>
          <li>
            <strong>Hiring firms:</strong> Deloitte · EY · KPMG · PwC · BDO ·
            RSM · Grant Thornton · Morgan Stanley · JP Morgan · Amazon ·
            Accenture · Genpact · Johnson &amp; Johnson · Wipro · HP · Barclays
            · PepsiCo · Philips · and 200+ more
          </li>
          <li>
            <strong>CMA job functions:</strong> FP&amp;A · Controllership ·
            Corporate Finance · Financial Reporting · Management Accounting ·
            Cost Management · Internal Controls · Advisory · Risk &amp; Strategy
            · GCC Finance · M&amp;A Analysis
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-11",
    question: "Why Miles Is the Best CMA Institute in India",
    answer: (
      <div className="about-section-content">
        <p>
          Miles Education is IMA&apos;s Diamond Partner and the world&apos;s
          largest CMA course provider. Our Miles CMA pass rate of ~76% versus
          the global average of ~45% is the clearest proof of what exceptional
          CMA coaching looks like. With 70,000+ alumni across India, the US, and
          globally, Miles is the undisputed #1 CMA coaching institute in India.
          Miles runs CMA classes across 9 cities &mdash; Bangalore · Hyderabad ·
          Mumbai · Delhi · Pune · Ahmedabad · Chennai · Kochi · Kolkata &mdash;
          and full CMA online classes through the Miles One App.
        </p>
        <p>
          <strong>What Miles students get:</strong>
        </p>
        <ul className="about-section-list">
          <li>
            50+ hours of concept video learning with Varun Jain, the
            world&apos;s favorite CMA instructor
          </li>
          <li>E-books (hard copies published by McGraw Hill)</li>
          <li>5,000+ MCQs with detailed explanations for both exam parts</li>
          <li>125+ Case-Based Questions in the CMA exam user interface</li>
          <li>
            Mock Exams &amp; 4-hour full-length practice exams in the CMA exam
            interface
          </li>
          <li>Live online sessions + weekend CMA classes across 9 cities</li>
          <li>1:1 mentorship (bookable slots on the LMS)</li>
          <li>Complete CMA enrollment guidance and IMA registration support</li>
          <li>
            License Track &mdash; dedicated Miles Gameplan Team guides you
            through the 3E requirements (Exams, Education, Experience)
          </li>
          <li>
            <strong>IMA bundle discounts</strong> on membership, entrance fees,
            and exam fees exclusively for Miles candidates &mdash; save
            approximately ₹40,000&ndash;₹50,000 on IMA registration alone
          </li>
          <li>Placement assistance with Big 4 &amp; 220+ MNCs</li>
          <li>
            CAIRA AI masterclasses: Microsoft Copilot, Power Automate, Power BI
            for Finance, Build AI Agents with Copilot Studio
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-12",
    question: "CMA Registration: How to Enroll",
    answer: (
      <div className="about-section-content">
        <p>
          Getting started with CMA registration through Miles is
          straightforward.
        </p>
        <ul className="about-section-list">
          <li>
            <strong>Step 1 &mdash; Enroll with Miles:</strong> Join the Miles
            CMA program and get immediate access to all study materials, the
            Miles One App, and your dedicated Gameplan Team advisor
          </li>
          <li>
            <strong>Step 2 &mdash; IMA Membership &amp; CMA Entrance:</strong>{" "}
            Your Miles Gameplan Team guides you through IMA membership
            registration and CMA entrance fee payment with the exclusive Miles
            bundle discount applied automatically
          </li>
          <li>
            <strong>Step 3 &mdash; Exam Registration:</strong> Register for your
            first exam part (Part 1 or Part 2) within your chosen testing window
            (Jan&ndash;Feb, May&ndash;Jun, or Sep&ndash;Oct)
          </li>
          <li>
            <strong>Step 4 &mdash; Study &amp; Appear:</strong> 18&ndash;20
            hours/week for 4 months per part. Miles provides structured study
            schedules, live sessions, MCQ banks, and mock exams
          </li>
          <li>
            <strong>Step 5 &mdash; Fulfill 3E Requirements:</strong> Pass both
            exams, complete your bachelor&apos;s degree (within 7 years), and
            accumulate 2 years of relevant work experience (within 7 years), and
            you earn your CMA designation
          </li>
          <li>
            No CMA registration last date in the traditional sense; IMA accepts
            applications year-round. Exam window registration deadlines apply
            &mdash; candidates must register at least 30 days before their
            chosen testing window opens
          </li>
        </ul>
      </div>
    ),
  },
  {
    value: "cma-13",
    question: "CMA Online Classes: Study Your Way",
    answer: (
      <div className="about-section-content">
        <p>
          Miles offers complete flexibility for how you study for the CMA exam
          &mdash; whether you prefer face-to-face CMA classes or CMA online
          classes.
        </p>
        <ul className="about-section-list">
          <li>
            <strong>CMA classes online via the Miles One App:</strong> 50+ hours
            of concept video lectures with Varun Jain on-demand · 5,000+ MCQs
            with explanations · 125+ case-based questions in the CMA exam
            interface · progress tracking, mock exams, and live webinars · CAIRA
            masterclasses integrated alongside CMA content · available 24/7
          </li>
          <li>
            <strong>CMA coaching in-person across 9 cities:</strong> Weekend
            face-to-face CMA classes in Bangalore, Hyderabad, Mumbai, Delhi,
            Pune, Ahmedabad, Chennai, Kochi, and Kolkata &mdash; taught live
            with Q&amp;A and peer interaction
          </li>
          <li>
            <strong>CMA coaching online:</strong> Live weekend sessions over
            Zoom with full recording access, so you never miss a class even if
            work gets in the way
          </li>
        </ul>
      </div>
    ),
  },
];

// Miles data
const milesData = [
  {
    value: "miles-1",
    question: "About Miles Education",
    answer:
      "The global talent landscape has critical gaps, but at Miles Education, we're not just filling these voids; we're building pathways to success. Driven by our mission to work backward from industry shortages, skill gaps, and opportunities, we empower businesses and enable talent by combining academic learning with hands-on experience through our unique ED-WORK Pedagogy.",
  },
];

const NewFaqSection = ({ pageName }: { pageName: string }) => {
  const [activeTab, setActiveTab] = useState("FAQs");
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const [expandedItems, setExpandedItems] = useState<Set<string>>(new Set());

  const toggleExpand = (value: string) => {
    setExpandedItems((prev) => {
      const next = new Set(prev);
      if (next.has(value)) next.delete(value);
      else next.add(value);
      return next;
    });
  };

  const getCurrentData = () => {
    switch (activeTab) {
      case "FAQs":
        return faqsData;
      case "CMA":
        return cmaData;
      case "Miles":
        return milesData;
      default:
        return faqsData;
    }
  };

  const visibleItems = showAllFaqs
    ? getCurrentData()
    : getCurrentData().slice(0, 3);

  const TAB_GRADIENT =
    "radial-gradient(1474.29% 161.47% at 113.4% 210.95%, #b9dcff 0%, #3a9cff 100%)";

  // Tailwind arbitrary variants for rich-text styles inside accordion answers
  const accordionRichText =
    // .answer
    "[&_.answer]:text-sm [&_.answer]:font-normal [&_.answer]:leading-6 " +
    // .faqList
    "[&_.faqList]:list-disc [&_.faqList]:ml-5 [&_.faqList]:text-sm [&_.faqList]:font-normal [&_.faqList]:my-1 " +
    // .faqTableWrapper
    "[&_.faqTableWrapper]:overflow-x-auto [&_.faqTableWrapper]:mt-3 [&_.faqTableWrapper]:mb-2 [&_.faqTableWrapper]:border [&_.faqTableWrapper]:border-[#E5EAF2] " +
    // .faqTable
    "[&_.faqTable]:w-full [&_.faqTable]:border-collapse [&_.faqTable]:text-[0.8rem] [&_.faqTable]:bg-white " +
    // .faqTable thead
    "[&_.faqTable_thead]:bg-[#EAF2FC] " +
    // .faqTable th & td
    "[&_.faqTable_th]:px-4 [&_.faqTable_th]:py-3 [&_.faqTable_th]:text-left [&_.faqTable_th]:text-[#1d1d1d] [&_.faqTable_th]:font-semibold [&_.faqTable_th]:align-top " +
    "[&_.faqTable_td]:px-4 [&_.faqTable_td]:py-3 [&_.faqTable_td]:text-left [&_.faqTable_td]:text-[#1d1d1d] [&_.faqTable_td]:align-top " +
    // zebra striping
    "[&_.faqTable_tbody_tr:nth-child(even)]:bg-[#F7FBFF] " +
    // first column muted label
    "[&_.faqTable_tbody_tr_td:first-child]:!text-[#94A3B8] [&_.faqTable_tbody_tr_td:first-child]:font-medium " +
    // .about-section-content
    "[&_.about-section-content]:text-sm [&_.about-section-content]:leading-[1.55] [&_.about-section-content]:text-[#999999] " +
    "[&_.about-section-content_p]:mt-0 [&_.about-section-content_p]:mb-3 " +
    // .about-section-list
    "[&_.about-section-list]:list-disc [&_.about-section-list]:mt-2 [&_.about-section-list]:mb-3 [&_.about-section-list]:ml-5 [&_.about-section-list]:text-sm " +
    "[&_.about-section-list_li]:mb-[0.35rem]";

  return (
    <section className="py-8 md:pt-12 md:pb-16 md:bg-[#FFFF]">
      <div className="main_container w-full px-4 md:max-w-[1280px] md:mx-auto md:px-6">
        <div className="flex flex-col gap-6 min-[1200px]:flex-row min-[1200px]:gap-8 min-[1200px]:items-stretch">
          {/* Form column — order 1 mobile, order 2 desktop */}
          <div
            id="live-webinar-section"
            className="w-full order-1 md:order-2 md:w-[380px] md:flex-[0_0_380px]"
          >
            <div
              id="live-webinar-form"
              className="rounded-2xl bg-white border border-[#DEE7F5] p-5"
              style={{
                transition: "all 0.5s ease-in-out",
                position: "sticky",
                top: 100,
              }}
            >
              <EnqueryForm
                pageName={pageName}
                courseId={pageName === "CMA" ? 2 : 1}
                darkBackground={false}
                submitButtonName="Request a Callback"
                formType="Footer section"
                isAStepperForm
                successMessage={SuccessMessageType.ACCOUNTING}
                formHeading={FormHeading.TALK_TO_AN_EXPERT}
              />
            </div>
          </div>

          {/* Content column — order 2 mobile, order 1 desktop */}
          <div className="w-full order-2 md:order-1 md:w-[833px] md:flex-[0_0_833px]">
            <div className="bg-white rounded-2xl py-6 px-4">
              <div className="flex flex-col justify-center md:flex-row md:gap-3 md:items-center md:justify-center">
                <h2 className="text-2xl font-bold text-center mb-4 text-[#333] md:text-[2rem] md:mb-0">
                  All About
                </h2>

                <div className="flex p-1 items-center rounded-2xl bg-[#f3f3f3] mb-6 w-full md:w-[337px] md:mb-0 md:flex-none">
                  <button
                    className={`flex p-2 justify-center items-center gap-2.5 flex-1 rounded-2xl border-0 text-base font-semibold cursor-pointer transition-all duration-300 md:text-lg ${
                      activeTab === "CMA"
                        ? "text-white"
                        : "bg-transparent text-[#1d1d1d]"
                    }`}
                    style={
                      activeTab === "CMA"
                        ? { background: TAB_GRADIENT }
                        : undefined
                    }
                    onClick={() => setActiveTab("CMA")}
                  >
                    CMA
                  </button>
                  <button
                    className={`flex p-2 justify-center items-center gap-2.5 flex-1 rounded-2xl border-0 text-base font-semibold cursor-pointer transition-all duration-300 md:text-lg ${
                      activeTab === "Miles"
                        ? "text-white"
                        : "bg-transparent text-[#1d1d1d]"
                    }`}
                    style={
                      activeTab === "Miles"
                        ? { background: TAB_GRADIENT }
                        : undefined
                    }
                    onClick={() => setActiveTab("Miles")}
                  >
                    Miles
                  </button>
                  <button
                    className={`flex p-2 justify-center items-center gap-2.5 flex-1 rounded-2xl border-0 text-base font-semibold cursor-pointer transition-all duration-300 md:text-lg ${
                      activeTab === "FAQs"
                        ? "text-white"
                        : "bg-transparent text-[#1d1d1d]"
                    }`}
                    style={
                      activeTab === "FAQs"
                        ? { background: TAB_GRADIENT }
                        : undefined
                    }
                    onClick={() => setActiveTab("FAQs")}
                  >
                    FAQs
                  </button>
                </div>
              </div>

              <div className="mt-4">
                {visibleItems.map((item) => {
                  const enableReadMore = activeTab === "CMA";
                  const isExpanded = expandedItems.has(item.value);
                  const isCollapsed = enableReadMore && !isExpanded;
                  return (
                    <div
                      key={item.value}
                      className={`flex flex-col gap-2.5 p-4 rounded-2xl bg-[#f7fbff] mb-4 border-0 ${accordionRichText}`}
                    >
                      <div className="text-base font-bold text-[#333] p-0 w-full text-left leading-normal md:text-lg">
                        {item.question}
                      </div>
                      <div
                        className={`relative p-0 text-sm font-normal leading-normal text-[#999] md:text-base ${
                          isCollapsed
                            ? "max-h-[140px] overflow-hidden"
                            : "overflow-hidden text-ellipsis"
                        }`}
                      >
                        {item.answer}
                        {isCollapsed && (
                          <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-[#f7fbff] to-transparent" />
                        )}
                      </div>
                      {enableReadMore && (
                        <button
                          type="button"
                          onClick={() => toggleExpand(item.value)}
                          className="self-start mt-1 inline-flex items-center bg-transparent text-[#39f] border-0 text-sm font-bold cursor-pointer p-0"
                        >
                          {isExpanded ? "Read Less" : "Read More"}
                        </button>
                      )}
                    </div>
                  );
                })}

                {getCurrentData().length > 3 && (
                  <button
                    className="flex items-center justify-center gap-1 mt-4 mx-auto p-0 bg-transparent text-[#39f] border-0 text-sm font-bold cursor-pointer w-full"
                    onClick={() => setShowAllFaqs(!showAllFaqs)}
                  >
                    {showAllFaqs ? "See Less" : "See More"}
                    <span
                      className="inline-flex transition-transform duration-200"
                      style={{
                        transform: showAllFaqs ? "rotate(180deg)" : "none",
                      }}
                    >
                      <DownArrowIcon />
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewFaqSection;
